import Axios from 'axios';

import { API_URL } from '../config';
import { checkDailyLoginExpiration } from '../utils';

export let buildData = {
  FE_GH_COMMIT_HASH: 'N/A',
  FE_BUILD_DATE: 'N/A',
};
try {
  buildData = require('../buildData.json');
} catch (e) {
  console.error('Build Data is not present, run yarn build to correct the issue', e);
}

export const axios = Axios.create({
  baseURL: API_URL,
});

axios.interceptors.request.use(function authRequestInterceptor(config) {
  if (checkDailyLoginExpiration()) {
    setTimeout(() => {
      window.location.href = '/login';
    }, 3000);
  }
  const auth_token = localStorage.getItem('token');
  if (auth_token && config.headers) {
    config.headers['Authorization'] = `Token ${auth_token}`;
  }
  if (config.headers) {
    config.headers['x-application'] = 'BARK';
    config.headers['x-fe-gh-commit-hash'] = buildData.FE_GH_COMMIT_HASH;
    config.headers['x-fe-build-date'] = buildData.FE_BUILD_DATE;
  }
  return config;
});
